import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { getWithExpiry } from '../../../Domain/Helpers/LocalStorageHelper';
import { getAggregators } from '../../../Infrastructure/Services/AggregatorService';

function AggregatorsPage({ setLoggedIn }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    const token = getWithExpiry('token');
    if (!token) { setLoggedIn(false); return; }
    setLoading(true);
    try {
      const result = await getAggregators(token);
      if (result) setData(result);
    } catch { toast.error('Failed to load aggregators'); }
    finally { setLoading(false); }
  }, [setLoggedIn]);

  useEffect(() => { load(); }, [load]);

  return (
    <div>
      <div className="page-header">
        <div>
          <h4 className="page-title">Aggregators</h4>
          <p className="page-subtitle">Manage game aggregator integrations</p>
        </div>
        <button className="btn btn-fadeblack btn-sm" onClick={load} disabled={loading}>
          {loading ? <span className="spinner-border spinner-border-sm me-1" /> : '↻'} Refresh
        </button>
      </div>

      <div className="card-section">
        {loading && data.length === 0 ? (
          <div className="text-center p-4">
            <div className="spinner-border text-secondary" role="status" />
          </div>
        ) : data.length === 0 ? (
          <div className="empty-state">
            <div className="empty-state-icon">⬡</div>
            <p>No aggregators found</p>
          </div>
        ) : (
          <table className="table table-hover table-sm align-middle">
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Game Launch URL</th>
                <th>Status</th>
                <th>Created At</th>
              </tr>
            </thead>
            <tbody>
              {data.map(row => (
                <tr key={row.id}>
                  <td><span className="badge bg-secondary">{row.id}</span></td>
                  <td><strong>{row.name}</strong></td>
                  <td><code style={{ fontSize: 11 }}>{row.game_launch_url || '—'}</code></td>
                  <td>
                    <span className={`badge ${row.is_active ? 'bg-success' : 'bg-danger'}`}>
                      {row.is_active ? 'Active' : 'Inactive'}
                    </span>
                  </td>
                  <td style={{ fontSize: 12, color: '#607d8b' }}>
                    {row.created_at ? new Date(row.created_at).toLocaleDateString() : '—'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default AggregatorsPage;
